<template>
  <div class="bg-gray-50 min-h-screen">
    <Header />

    <div class="flex min-h-[calc(100vh-80px)] relative">
      <!-- MOBILE MENU BUTTON -->

      <button
        v-if="!showSidebar"
        @click="showSidebar = true"
        class="md:hidden fixed top-[80px] left-0 z-50 bg-blue-600 text-white p-2 rounded-r-lg shadow-lg"
        aria-label="Open menu"
      >
        <svg
          class="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
      </button>

      <!-- MOBILE OVERLAY -->
      <div
        v-if="showSidebar"
        @click="showSidebar = false"
        class="fixed inset-0 bg-black bg-opacity-30 z-30 md:hidden"
      ></div>

      <!-- SIDEBAR -->

      <!-- SIDEBAR -->
      <div
        :class="[
          'fixed md:static md:h-auto top-[80px] md:top-0 left-0 h-[calc(100vh-80px)] w-64 sm:w-72 md:w-64 lg:w-72 bg-white border-r border-gray-200 z-40 transform transition-transform duration-300 overflow-y-auto overscroll-contain',
          showSidebar ? 'translate-x-0' : '-translate-x-full',
          'md:translate-x-0',
        ]"
      >
        <!-- CLOSE BUTTON (MOBILE) - flush bar, no gap above -->
        <div
          class="sticky top-0 bg-white z-10 flex justify-end md:hidden px-3 py-2 border-b border-gray-100"
        >
          <button @click="showSidebar = false" aria-label="Close menu">
            <svg
              class="w-6 h-6 text-gray-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <nav class="space-y-1 sm:space-y-2 p-4 pb-8">
          <!-- LOGIN -->
          <button
            @click="switchTab('login')"
            :class="[
              'flex w-full items-center gap-3 px-3 sm:px-4 py-2 text-sm font-medium rounded-lg transition-colors',
              activeTab === 'login'
                ? 'text-blue-600 bg-blue-50'
                : 'text-gray-700 hover:bg-gray-100',
            ]"
          >
            <svg
              class="w-5 h-5 shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l3 3m0 0l-3 3m3-3H3"
              />
            </svg>
            <span class="truncate">login</span>
          </button>

          <!-- HOME -->
          <button
            @click="switchTab('home')"
            :class="[
              'flex w-full items-center gap-3 px-3 sm:px-4 py-2 text-sm font-medium rounded-lg transition-colors',
              activeTab === 'home'
                ? 'text-blue-600 bg-blue-50'
                : 'text-gray-700 hover:bg-gray-100',
            ]"
          >
            <svg
              class="w-5 h-5 shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
              />
            </svg>
            <span class="truncate">Home</span>
          </button>

          <!-- COURSE -->
          <button
            @click="switchTab('course')"
            :class="[
              'flex w-full items-center gap-3 px-3 sm:px-4 py-2 text-sm font-medium rounded-lg transition-colors',
              activeTab === 'course'
                ? 'text-blue-600 bg-blue-50'
                : 'text-gray-700 hover:bg-gray-100',
            ]"
          >
            <svg
              class="w-5 h-5 shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
              />
            </svg>
            <span class="truncate">course</span>
          </button>

          <!-- LESSON -->
          <button
            @click="switchTab('lesson')"
            :class="[
              'flex w-full items-center gap-3 px-3 sm:px-4 py-2 text-sm font-medium rounded-lg transition-colors',
              activeTab === 'lesson'
                ? 'text-blue-600 bg-blue-50'
                : 'text-gray-700 hover:bg-gray-100',
            ]"
          >
            <svg
              class="w-5 h-5 shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25"
              />
            </svg>
            <span class="truncate">lesson</span>
          </button>

          <!-- MESSAGE -->
          <button
            @click="switchTab('message')"
            :class="[
              'flex w-full items-center gap-3 px-3 sm:px-4 py-2 text-sm font-medium rounded-lg transition-colors',
              activeTab === 'message'
                ? 'text-blue-600 bg-blue-50'
                : 'text-gray-700 hover:bg-gray-100',
            ]"
          >
            <svg
              class="w-5 h-5 shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm3.75 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM21 12c0 4.556-4.03 8.25-9 8.25a9.764 9.764 0 01-2.555-.337A5.972 5.972 0 015.41 20.97a5.969 5.969 0 01-.474-.065 4.48 4.48 0 00.978-2.025c.09-.457-.133-.901-.467-1.226C3.93 16.178 3 14.189 3 12c0-4.556 4.03-8.25 9-8.25s9 3.694 9 8.25z"
              />
            </svg>
            <span class="truncate">message</span>
          </button>

          <!-- ASSIGNMENT -->
          <button
            @click="switchTab('assignment')"
            :class="[
              'flex w-full items-center gap-3 px-3 sm:px-4 py-2 text-sm font-medium rounded-lg transition-colors',
              activeTab === 'assignment'
                ? 'text-blue-600 bg-blue-50'
                : 'text-gray-700 hover:bg-gray-100',
            ]"
          >
            <svg
              class="w-5 h-5 shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08M9.75 4.5a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zM8.25 8.25H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25z"
              />
            </svg>
            <span class="truncate">assignment</span>
          </button>

          <!-- FORUMS -->
          <button
            @click="switchTab('forums')"
            :class="[
              'flex w-full items-center gap-3 px-3 sm:px-4 py-2 text-sm font-medium rounded-lg transition-colors',
              activeTab === 'forums'
                ? 'text-blue-600 bg-blue-50'
                : 'text-gray-700 hover:bg-gray-100',
            ]"
          >
            <svg
              class="w-5 h-5 shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
              />
            </svg>
            <span class="truncate">Forums</span>
          </button>

          <!-- LIVE CLASS -->
          <button
            @click="switchTab('liveclass')"
            :class="[
              'flex w-full items-center gap-3 px-3 sm:px-4 py-2 text-sm font-medium rounded-lg transition-colors',
              activeTab === 'liveclass'
                ? 'text-blue-600 bg-blue-50'
                : 'text-gray-700 hover:bg-gray-100',
            ]"
          >
            <svg
              class="w-5 h-5 shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-9A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25z"
              />
            </svg>
            <span class="truncate">Liveclass</span>
          </button>

          <!-- ASSESSMENT -->
          <button
            @click="switchTab('assessment')"
            :class="[
              'flex w-full items-center gap-3 px-3 sm:px-4 py-2 text-sm font-medium rounded-lg transition-colors',
              activeTab === 'assessment'
                ? 'text-blue-600 bg-blue-50'
                : 'text-gray-700 hover:bg-gray-100',
            ]"
          >
            <svg
              class="w-5 h-5 shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"
              />
            </svg>
            <span class="truncate">Assessment</span>
          </button>

          <!-- PROJECT / TEAM LEADER -->
          <button
            @click="switchTab('project')"
            :class="[
              'flex w-full items-center gap-3 px-3 sm:px-4 py-2 text-sm font-medium rounded-lg transition-colors',
              activeTab === 'project'
                ? 'text-blue-600 bg-blue-50'
                : 'text-gray-700 hover:bg-gray-100',
            ]"
          >
            <svg
              class="w-5 h-5 shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0"
              />
            </svg>
            <span class="truncate">project</span>
          </button>

          <!-- NOTIFICATION -->
          <button
            @click="switchTab('notification')"
            :class="[
              'flex w-full items-center gap-3 px-3 sm:px-4 py-2 text-sm font-medium rounded-lg transition-colors',
              activeTab === 'notification'
                ? 'text-blue-600 bg-blue-50'
                : 'text-gray-700 hover:bg-gray-100',
            ]"
          >
            <svg
              class="w-5 h-5 shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0"
              />
            </svg>
            <span class="truncate">notification</span>
          </button>
          <!-- MESSAGE NOTIFICATION -->
          <button
            @click="switchTab('messagepage')"
            :class="[
              'flex w-full items-center gap-3 px-3 sm:px-4 py-2 text-sm font-medium rounded-lg transition-colors',
              activeTab === 'messagepage'
                ? 'text-blue-600 bg-blue-50'
                : 'text-gray-700 hover:bg-gray-100',
            ]"
          >
            <svg
              class="w-5 h-5 shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 01-.825-.242m9.345-8.334a2.126 2.126 0 00-.476-.095 48.64 48.64 0 00-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0011.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"
              />
            </svg>
            <span class="truncate">message notification</span>
          </button>

          <!-- PROFILE -->
          <button
            @click="switchTab('profile')"
            :class="[
              'flex w-full items-center gap-3 px-3 sm:px-4 py-2 text-sm font-medium rounded-lg transition-colors',
              activeTab === 'profile'
                ? 'text-blue-600 bg-blue-50'
                : 'text-gray-700 hover:bg-gray-100',
            ]"
          >
            <svg
              class="w-5 h-5 shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
            <span class="truncate">profile</span>
          </button>

          <!-- ACCESSIBLE COURSE -->
          <button
            @click="switchTab('accessible')"
            :class="[
              'flex w-full items-center gap-3 px-3 sm:px-4 py-2 text-sm font-medium rounded-lg transition-colors',
              activeTab === 'accessible'
                ? 'text-blue-600 bg-blue-50'
                : 'text-gray-700 hover:bg-gray-100',
            ]"
          >
            <svg
              class="w-5 h-5 shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 5.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z"
              />
            </svg>
            <span class="truncate">accessible</span>
          </button>

          <!-- TASK MANAGEMENT -->
          <button
            @click="switchTab('task')"
            :class="[
              'flex w-full items-center gap-3 px-3 sm:px-4 py-2 text-sm font-medium rounded-lg transition-colors',
              activeTab === 'task'
                ? 'text-blue-600 bg-blue-50'
                : 'text-gray-700 hover:bg-gray-100',
            ]"
          >
            <svg
              class="w-5 h-5 shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12.75l1.5 1.5 4.5-4.5m5.25 3a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <span class="truncate">task management</span>
          </button>

          <!-- USER INSTRUCTION -->
          <button
            @click="switchTab('userinstruction')"
            :class="[
              'flex w-full items-center gap-3 px-3 sm:px-4 py-2 text-sm font-medium rounded-lg transition-colors',
              activeTab === 'userinstruction'
                ? 'text-blue-600 bg-blue-50'
                : 'text-gray-700 hover:bg-gray-100',
            ]"
          >
            <svg
              class="w-5 h-5 shrink-0"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
              />
            </svg>
            <span class="truncate">user instruction</span>
          </button>
        </nav>
      </div>

      <!-- MAIN CONTENT -->
      <div class="flex-1 w-full min-w-0 max-w-6xl p-4 sm:p-6 md:p-8 lg:p-10">
        <div class="pl-0 md:pl-6" v-if="activeTab === 'login'">
          <img
            class="w-full max-w-full h-auto object-contain rounded-lg shadow-sm border border-gray-200"
            src="@/assets/help/studentLoginpage1.png"
            alt="Student login page"
          />
          <div class="mt-5">
            <h1 class="text-lg sm:text-xl font-semibold text-blue-600">
              Features Available:
            </h1>
            <p class="text-sm text-gray-700 leading-relaxed">
              <br /><br />
              1) Email Authentication
              <br />Students can log in using their registered email address.
              <br />The system validates the email before granting access.
              <br /><br />
              2) Password Authentication
              <br />Students must enter their password to access their account.
              <br />Passwords are securely verified by the system. <br /><br />
              3) Show/Hide Password
              <br />An eye icon is provided in the password field.
              <br />Students can view or hide their password while typing.
              <br /><br />
              4) Forgot Password
              <br />A "Forgot Password?" link is available. <br />Students can
              reset their password through the password recovery process.
              <br /><br />
              5) Secure Login
              <br />Only authorized students can access the platform.
              <br />Invalid credentials are rejected with appropriate validation
              messages. <br /><br />
              6) Responsive User Interface
              <br />Clean and user-friendly login design. <br />Accessible from
              desktop and mobile devices. <br /><br />
              7) Branding and Student-Friendly Design
              <br />Institution branding/logo is displayed.
              <br />Student-focused visual design improves user experience.
            </p>
          </div>
        </div>

        <div class="pl-0 md:pl-6" v-if="activeTab === 'home'">
          <img
            class="w-full max-w-full h-auto object-contain rounded-lg shadow-sm border border-gray-200"
            src="@/assets/help/homepage.png"
            alt="Student home page"
          />
          <div class="mt-5">
            <h1 class="text-lg sm:text-xl font-semibold text-blue-600">
              Student Course Access Module
            </h1>

            <p class="text-sm text-gray-700 leading-relaxed mt-5">
              1) Dashboard Access — Students can access a personalized learning
              dashboard after login. Provides an overview of courses, tasks, and
              announcements.
              <br /><br />
              2) Active Courses — Displays all enrolled and active courses.
              Students can easily access their assigned courses.
              <br /><br />
              3) Continue Learning — Allows students to resume courses from
              their last learning progress. Ensures uninterrupted learning
              experience.
              <br /><br />
              4) Course Modules — Shows the total number of modules available in
              each course. Helps students track course content and structure.
              <br /><br />
              5) Course Navigation — Course cards provide quick access to
              learning materials. Enables easy navigation between courses.
              <br /><br />
              6) Calendar Management — Displays academic schedules and important
              dates. Helps students stay updated on upcoming activities.
              <br /><br />
              7) Announcements — Shows important notices and academic updates.
              Keeps students informed about course-related information.
              <br /><br />
              8) Learning Resources — Provides access to orientation materials
              and LMS guides. Supports students in using the platform
              effectively.
              <br /><br />
              9) Task Management — Displays daily tasks and learning activities.
              Helps students manage and complete assigned work.
              <br /><br />
              10) View All Courses — Allows students to view the complete list
              of enrolled courses. Provides centralized access to all learning
              content.
              <br /><br />
              11) Secure Course Access — Only authorized students can access
              assigned courses. Protects course content through secure
              authentication.
              <br /><br />
              12) Responsive User Interface — Accessible on desktop, tablet, and
              mobile devices. Ensures a consistent learning experience across
              platforms.
            </p>
          </div>
        </div>

        <div class="pl-0 md:pl-6" v-if="activeTab === 'course'">
          <img
            class="w-full max-w-full h-auto object-contain rounded-lg shadow-sm border border-gray-200"
            src="@/assets/help/homepage2.png"
            alt="My courses page"
          />
          <div class="mt-5">
            <h1 class="text-lg sm:text-xl font-semibold text-blue-600">
              My Courses Module
            </h1>

            <p class="text-sm text-gray-700 leading-relaxed mt-5">
              The My Courses page enables students to access and manage all
              their enrolled courses from a centralized location.
            </p>

            <p class="text-sm text-gray-700 leading-relaxed">
              1) Semester-Based Course View
              <br />Courses are organized based on the student's semester.
              <br />Students can easily view courses assigned to their current
              semester. <br /><br />
              2) Course Listing
              <br />Displays all enrolled courses in a structured card layout.
              <br />Provides a clear overview of available subjects.
              <br /><br />
              3) Course Information
              <br />Each course card displays the course name. <br />Course code
              is shown for easy identification. <br /><br />
              4) Course Thumbnail
              <br />Each course includes a visual banner or thumbnail.
              <br />Helps students quickly recognize courses. <br /><br />
              5) Continue Learning
              <br />A "Continue Learning" button is available for every course.
              <br />Students can resume learning from their previous progress.
              <br /><br />
              6) User-Friendly Interface
              <br />Clean and organized course layout. <br />Makes course
              navigation simple and intuitive. <br /><br />
              7) Responsive Design
              <br />Accessible on desktop, tablet, and mobile devices.
              <br />Ensures a consistent learning experience across platforms.
              <br /><br />
              8) Secure Course Access
              <br />Only authorized students can access their enrolled courses.
              <br />Protects academic content through secure authentication.
            </p>
          </div>
        </div>

        <div class="pl-0 md:pl-6" v-if="activeTab === 'lesson'">
          <img
            class="w-full max-w-full h-auto object-contain rounded-lg shadow-sm border border-gray-200"
            src="@/assets/help/lessonpage3.png"
            alt="Course learning page"
          />
          <div class="mt-5">
            <h1 class="text-lg sm:text-xl font-semibold text-blue-600">
              Course Learning Module
            </h1>

            <p class="text-sm text-gray-700 leading-relaxed mt-5">
              The Course Learning Module provides students with complete access
              to course materials, learning resources, assessments,
              communication tools, and progress tracking within a single
              interface.
            </p>

            <p class="text-sm text-gray-700 leading-relaxed">
              1) Course Overview:
              <br />Displays the selected course name and banner. <br />Provides
              a brief introduction, objectives, and course description.
              <br /><br />
              2) Learning Progress Tracking:
              <br />Shows course completion percentage. <br />Helps students
              monitor their learning progress. <br /><br />
              3) Continue Learning:
              <br />Allows students to resume learning from their last completed
              section. <br />Ensures a seamless learning experience.
              <br /><br />
              4) Module Information:
              <br />Displays the total number of course modules. <br />Shows the
              estimated duration of the course. <br /><br />
              5) Course Objectives:
              <br />Provides the learning goals and expected outcomes of the
              course. <br />Helps students understand the purpose of the course.
              <br /><br />
              6) Course Description:
              <br />Displays detailed information about the course content.
              <br />Gives students an overview of topics covered. <br /><br />
              7) Course Resources &amp; Documents:
              <br />Provides downloadable learning materials and reference
              documents. <br />Enables students to access course-related
              resources anytime. <br /><br />
              8) Course Content Management:
              <br />Organizes learning materials into structured modules.
              <br />Allows students to navigate through lessons easily.
              <br /><br />
              9) Syllabus Access:
              <br />Provides access to the complete course syllabus. <br />Helps
              students understand the course structure and requirements.
              <br /><br />
              10) Live Class Recordings:
              <br />Gives access to recorded live sessions. <br />Allows
              students to review lectures at their convenience. <br /><br />
              11) Lesson Management:
              <br />Displays individual course lessons and learning units.
              <br />Supports step-by-step learning progression. <br /><br />
              12) Messages:
              <br />Enables communication between students and instructors.
              <br />Facilitates course-related discussions and support.
              <br /><br />
              13) Assignments:
              <br />Allows students to view and submit assignments.
              <br />Supports assessment and performance evaluation. <br /><br />
              14) Discussion Forums:
              <br />Provides a collaborative platform for academic discussions.
              <br />Encourages peer-to-peer learning and interaction.
              <br /><br />
              15) Live Classes:
              <br />Enables participation in scheduled online classes.
              <br />Supports real-time learning and instructor engagement.
              <br /><br />
              16) Assessments:
              <br />Provides quizzes, tests, and evaluations. <br />Measures
              student understanding and performance. <br /><br />
              17) Projects:
              <br />Allows students to complete practical project-based
              activities. <br />Enhances hands-on learning and skill
              development. <br /><br />
              18) Support Tickets:
              <br />Enables students to raise support requests and queries.
              <br />Helps resolve technical or academic issues efficiently.
              <br /><br />
              19) Semester Examination:
              <br />Provides access to semester examination information and
              activities. <br />Supports academic evaluation and course
              completion. <br /><br />
              20) Secure Course Access:
              <br />Ensures that only authorized students can access course
              content. <br />Protects learning resources through secure
              authentication. <br /><br />
              21) Responsive User Interface:
              <br />Accessible on desktop, tablet, and mobile devices.
              <br />Provides a consistent learning experience across platforms.
            </p>
          </div>
        </div>

        <div class="pl-0 md:pl-6" v-if="activeTab === 'message'">
          <img
            class="w-full max-w-full h-auto object-contain rounded-lg shadow-sm border border-gray-200"
            src="@/assets/help/messagepage5.png"
            alt="Messages page"
          />
          <div class="mt-5">
            <h1 class="text-lg sm:text-xl font-semibold text-blue-600">
              Course Messages Module
            </h1>
            <p class="text-sm text-gray-700 leading-relaxed mt-5">
              1) One-to-One Chat
              <br />Students can communicate directly with instructors regarding
              course-related topics. <br />Students can view and access previous
              conversation history for reference. <br /><br />
              2) Document Upload
              <br />Students can upload course-related documents such as
              assignments, reports, and study materials. <br />Uploaded
              documents can be shared with instructors for review and feedback.
              <br /><br />
              3) Image Upload
              <br />Students can upload images related to coursework, projects,
              or assignments. <br />Images can be shared within conversations to
              support academic discussions. <br /><br />
              4) Video Upload
              <br />Students can upload course-related videos such as project
              demonstrations or presentations. <br />Instructors can review
              uploaded videos and provide feedback. <br /><br />
              5) Contact Search
              <br />Students can search for instructors and authorized course
              participants using the search bar. <br />Quick access to contacts
              helps students start conversations efficiently. <br /><br />
              6) Secure Communication
              <br />All messages and shared files are accessible only to
              authorized course users. <br />Student communication is restricted
              to course-related participants. <br /><br />
              7) Access Restrictions
              <br />Students can communicate only with instructors and
              authorized course users. <br />Students cannot send messages or
              initiate chats with administrators through this module.
              <br /><br />
              8) Instructor Features
              <br />Instructors can receive and respond to student messages.
              <br />Instructors can view and review uploaded documents, images,
              and videos shared by students.
            </p>
          </div>
        </div>

        <div class="pl-0 md:pl-6" v-if="activeTab === 'assignment'">
          <img
            class="w-full max-w-full h-auto object-contain rounded-lg shadow-sm border border-gray-200"
            src="@/assets/help/assignmentpage6.png"
            alt="Assignments page"
          />
          <div class="mt-5">
            <h1 class="text-lg sm:text-xl font-semibold text-blue-600">
              Assignment Module – Student Features
            </h1>
            <p class="text-sm text-gray-700 leading-relaxed mt-5">
              1) View Assignments
              <br />Students can view all assignments created by instructors for
              the enrolled course. <br />Assignment details include title,
              description, due date, and submission status. <br /><br />
              2) Assignment Calendar Integration
              <br />Assignments are automatically displayed on the course
              calendar based on their due dates. <br />Students can track
              upcoming deadlines and submission schedules from the calendar
              view. <br /><br />
              3) File-Based Assignment Submission
              <br />Students can submit assignments by uploading files in the
              supported format. <br />Uploaded files are securely stored and
              linked to the corresponding assignment. <br /><br />
              4) Submission After Due Date
              <br />Students are allowed to submit assignments even after the
              due date has passed. <br />The system records the actual
              submission date and time for instructor review. <br /><br />
              5) Submission Status Tracking
              <br />Students can view the current status of each submitted
              assignment. <br />Status updates are displayed as Pending,
              Accepted, or Rejected. <br /><br />
              6) Create Assignments
              <br />Instructors can create assignments for a specific course.
              <br />Assignment creation includes title, description,
              instructions, due date, and file submission requirements.
              <br /><br />
              7) Review Student Submissions
              <br />Instructors can access and review all submitted assignment
              files. <br />Submission timestamps help identify on-time and late
              submissions. <br /><br />
              8) Accept Assignment Submission
              <br />Instructors can approve a student's submission after
              evaluation. <br />Once an assignment is marked as Accepted, the
              status becomes final and cannot be changed. <br /><br />
              9) Reject Assignment Submission
              <br />Instructors can reject a submission if it does not meet the
              requirements. <br />A rejected assignment can be reviewed again
              and rejected multiple times until it satisfies the evaluation
              criteria. <br /><br />
              10) Due Date Management
              <br />Instructors define assignment deadlines during creation.
              <br />Due dates are used for calendar display and submission
              tracking purposes. <br /><br />
              11) Assignment Feedback
              <br />Instructors can enable or disable feedback for each
              assignment during assignment creation. <br />When feedback is
              enabled, students can submit feedback related to the assignment
              after submission or evaluation. <br /><br />
              12) Feedback Access Control
              <br />If feedback is enabled, students can provide comments,
              suggestions, or responses for the assignment. <br />If feedback is
              disabled, the feedback option will not be visible to students and
              no feedback can be submitted. <br /><br />
              13) Instructor Feedback Management
              <br />Instructors can decide whether feedback collection is
              required for a particular assignment. <br />Feedback settings can
              be configured individually for each assignment during creation.
            </p>
          </div>
        </div>

        <div class="pl-0 md:pl-6" v-if="activeTab === 'forums'">
          <img
            class="w-full max-w-full h-auto object-contain rounded-lg shadow-sm border border-gray-200"
            src="@/assets/help/forumspage7.png"
            alt="Forums page"
          />
          <div class="mt-5">
            <h1 class="text-lg sm:text-xl font-semibold text-blue-600">
              Group Discussion Forum – Student & Instructor Features
            </h1>

            <p class="text-sm text-gray-700 leading-relaxed mt-5">
              1) Group Creation (Instructor/Staff)
              <br />Instructors can create discussion groups for assignments,
              projects, or course-related activities. <br />Instructors can add
              specific students to a group based on participation requirements.
              <br /><br />
              2) Group Membership Management
              <br />Only students added by the instructor can access and
              participate in the group. <br />Instructors can manage group
              members by adding or removing students when required. <br /><br />
              3) Group Chat
              <br />Students can participate in group-based discussions with
              other assigned members. <br />All group members can view messages
              and contribute to the conversation. <br /><br />
              4) Image Sharing
              <br />Students can upload and share images within the group
              discussion. <br />Images can be used to support project work,
              assignments, and academic discussions. <br /><br />
              5) Document Sharing
              <br />Students can upload and share course-related documents
              within the group. <br />Shared documents are accessible to all
              members of the discussion group. <br /><br />
              6) Video Sharing
              <br />Students can upload and share videos related to assignments,
              presentations, or projects. <br />Group members can review shared
              videos for collaboration and discussion. <br /><br />
              7) Assignment and Project Discussions
              <br />Groups can be created specifically for assignment or project
              collaboration. <br />Students can discuss requirements, share
              resources, and coordinate tasks within the group. <br /><br />
              8) Instructor Participation
              <br />Instructors can monitor group discussions and provide
              guidance when needed. <br />Instructors can share announcements,
              instructions, and learning resources with all group members.
              <br /><br />
              9) Access Control
              <br />Only authorized students and instructors assigned to the
              group can access the discussion. <br />Students cannot create
              groups independently unless permission is provided by the
              instructor. <br />Group discussions are restricted to
              course-related communication and collaboration.
            </p>
          </div>
        </div>

        <div class="pl-0 md:pl-6" v-if="activeTab === 'liveclass'">
          <img
            class="w-full max-w-full h-auto object-contain rounded-lg shadow-sm border border-gray-200"
            src="@/assets/help/liveclasspage8.png"
            alt="Live class page"
          />
          <div class="mt-5">
            <h1 class="text-lg sm:text-xl font-semibold text-blue-600">
              Live Class Module
            </h1>

            <p class="text-sm text-gray-700 leading-relaxed mt-5">
              1) Live Class Creation
              <br />Instructors can create and schedule live classes for
              specific courses and batches. <br />Class schedules include title,
              meeting platform, start date, and end date. <br /><br />

              2) Meeting Platform Integration
              <br />Live classes can be integrated with Zoom, Microsoft Teams,
              or Google Meet. <br />Students can join sessions directly through
              the LMS using the meeting link. <br /><br />

              3) Class Scheduling Management
              <br />Instructors can reschedule, update, or cancel scheduled
              classes. <br />Students can view upcoming, ongoing, and completed
              classes. <br /><br />

              4) Join Class Access Control
              <br />The Join Class button is enabled only during the scheduled
              class duration. <br />Before the start time and after the end
              time, the button remains disabled. <br /><br />

              5) Class Status Management
              <br />Classes are automatically marked as Upcoming, Live, or
              Ended. <br />Status updates are based on the configured start and
              end time. <br /><br />

              6) Attendance Tracking
              <br />Student attendance is recorded automatically when joining a
              live session. <br />Instructors can view attendance reports and
              participation records. <br /><br />

              7) Session Recording Access
              <br />Recorded sessions can be uploaded or synced from the meeting
              platform. <br />Students can access recordings for revision and
              missed classes. <br /><br />

              8) Notifications and Reminders
              <br />Students receive notifications when a class is scheduled.
              <br />Automated reminders are sent before the class start time.
              <br /><br />

              9) Resource Sharing
              <br />Instructors can share documents, presentations, and
              reference materials. <br />Students can access all shared
              resources related to the live class. <br /><br />

              10) Feedback Collection
              <br />Students can submit feedback after attending a live class.
              <br />Instructors can review ratings and comments for improvement.
              <br /><br />

              11) Instructor Monitoring
              <br />Instructors can monitor attendance and student
              participation. <br />Announcements and important instructions can
              be shared during the session. <br /><br />

              12) Security and Access Control
              <br />Only enrolled students can access scheduled live classes.
              <br />Meeting access is restricted through LMS authentication.
              <br /><br />

              13) Reports and Analytics
              <br />Attendance, participation, and completion reports are
              available. <br />Administrators can monitor live class engagement
              and performance. <br /><br />

              14) Mobile and Cross-Platform Access
              <br />Students can join classes using desktop, tablet, or mobile
              devices. <br />The platform supports major browsers and operating
              systems. <br /><br />

              15) Feedback Management
              <br />Instructors can enable or disable feedback collection while
              creating or editing a live class. <br />Feedback settings are
              configured individually for each live session. <br /><br />

              16) Feedback Access Control
              <br />When feedback is enabled by the instructor, students can
              submit feedback after attending the class. <br />When feedback is
              disabled, the feedback option is not displayed to students.
              <br /><br />

              17) Student Feedback Submission
              <br />Students can provide ratings, comments, and suggestions for
              the live session. <br />Feedback can only be submitted by students
              enrolled in the class. <br /><br />

              18) Feedback Visibility
              <br />Submitted feedback is available to instructors and
              administrators for review. <br />Students cannot view feedback
              submitted by other participants unless permissions are granted.
              <br /><br />

              19) Feedback Reports
              <br />Instructors can analyze feedback ratings and comments to
              improve future sessions. <br />Feedback reports can be generated
              for individual classes or courses.
            </p>
          </div>
        </div>

        <div class="pl-0 md:pl-6" v-if="activeTab === 'assessment'">
          <img
            class="w-full max-w-full h-auto object-contain rounded-lg shadow-sm border border-gray-200"
            src="@/assets/help/assessmentpage9.png"
            alt="Assessment page"
          />
          <div class="mt-5">
            <h1 class="text-lg sm:text-xl font-semibold text-blue-600">
              Assessment Module
            </h1>

            <p class="text-sm text-gray-700 leading-relaxed mt-5">
              1) Assessment Creation
              <br />Instructors can create module-based quizzes and assessments
              for each course module. <br />Assessments can include
              multiple-choice questions, descriptive questions, or other
              question types. <br /><br />

              2) Assessment Availability
              <br />Assessments are displayed to students based on the
              configured start date and availability settings. <br />Students
              can access only the assessments assigned to their enrolled course.
              <br /><br />

              3) Assessment Preview
              <br />Students can preview assessment details before starting the
              quiz. <br />Preview may include assessment instructions, duration,
              total questions, and attempt limits. <br /><br />

              4) Assessment Attempt Management
              <br />The system tracks the number of attempts made by each
              student. <br />Students can attempt the assessment only up to the
              maximum attempt limit defined by the instructor. <br /><br />

              5) Student Attempt Tracking
              <br />The "Student Attempt" column displays the number of attempts
              already used by the student. <br />Students can monitor their
              remaining attempts before starting the assessment. <br /><br />

              6) Total Attempt Limit
              <br />The "Total Attempt" column shows the maximum number of
              attempts allowed. <br />Once the attempt limit is reached,
              students cannot retake the assessment unless additional attempts
              are granted. <br /><br />

              7) Quiz Start Control
              <br />Students can start an assessment using the Start button.
              <br />The Start button is enabled only when the assessment is
              available and attempt limits have not been exceeded. <br /><br />

              8) Assessment Submission
              <br />Students can submit their responses after completing the
              assessment. <br />Submitted assessments are automatically recorded
              in the system. <br /><br />

              9) Assessment Status Management
              <br />The system displays the assessment status, such as Not
              Started, In Progress, or Submitted. <br />Students can easily
              identify pending and completed assessments. <br /><br />

              10) Assessment Feedback Management
              <br />Instructors can enable or disable feedback collection for
              individual assessments. <br />When feedback is enabled, students
              can provide ratings and comments after completing the assessment.
              <br /><br />

              11) Automated Feedback Access
              <br />If Enable Feedback = Yes, the Feedback option becomes
              available after assessment submission. <br />If Enable Feedback =
              No, students cannot access the feedback form. <br /><br />

              12) Assessment Results and Performance
              <br />Students can view their assessment results based on
              instructor settings. <br />Instructors can analyze student
              performance and assessment completion reports. <br /><br />

              13) Security and Access Control
              <br />Only enrolled students can access course assessments.
              <br />Assessment attempts, submissions, and results are secured
              through LMS authentication and authorization controls.
              <br /><br />

              14) Assessment Feedback
              <br />Instructors can enable or disable feedback collection for
              individual assessments during assessment creation. <br />Feedback
              settings are controlled separately for each assessment.
              <br /><br />

              15) Feedback Availability
              <br />When feedback is enabled by the instructor, students can
              submit feedback after completing the assessment. <br />When
              feedback is disabled, the feedback option is not displayed to
              students. <br /><br />

              16) Student Feedback Submission
              <br />Students can provide ratings, comments, and suggestions
              regarding the assessment. <br />Feedback can be submitted only
              after a successful assessment attempt. <br /><br />

              17) Feedback Button Control
              <br />If Enable Feedback = Yes, the Feedback button is displayed
              after assessment completion. <br />If Enable Feedback = No, the
              Feedback button remains hidden or disabled. <br /><br />

              18) Feedback Review
              <br />Instructors and administrators can review submitted feedback
              from students. <br />Feedback helps evaluate assessment quality,
              difficulty level, and overall student experience. <br /><br />

              19) Feedback Analytics
              <br />Feedback reports can be generated to analyze student
              satisfaction and assessment effectiveness. <br />Instructors can
              use feedback insights to improve future assessments and course
              content.
            </p>
          </div>
        </div>

        <div class="pl-0 md:pl-6" v-if="activeTab === 'project'">
          <img
            class="w-full max-w-full h-auto object-contain rounded-lg shadow-sm border border-gray-200"
            src="@/assets/help/projectpage10.png"
            alt="Project / team leader page"
          />
          <div class="mt-5">
            <h1 class="text-lg sm:text-xl font-semibold text-blue-600">
              Team Leader Module
            </h1>

            <p class="text-sm text-gray-700 leading-relaxed mt-5">
              1) Team Leader Assignment
              <br />Instructors can assign a Team Leader for each project team.
              <br />The Team Leader is responsible for coordinating team
              activities and communication. <br /><br />

              2) Team Member Management
              <br />Team Leaders can manage team members based on permissions
              granted by the instructor. <br />Team Leaders can request adding
              or removing members, subject to instructor approval. <br /><br />

              3) Task Coordination
              <br />Team Leaders can assign tasks and responsibilities to team
              members. <br />Team Leaders can monitor task progress and ensure
              project deadlines are met. <br /><br />

              4) Team Communication
              <br />Team Leaders can initiate discussions, share announcements,
              and coordinate project activities. <br />Team Leaders act as the
              primary point of contact between instructors and team members.
              <br /><br />

              5) Project Submission Management
              <br />Team Leaders can submit project deliverables on behalf of
              the team. <br />Team members can review submission status and
              project updates. <br /><br />

              6) Progress Monitoring
              <br />Team Leaders can track member participation and project
              completion progress. <br />Instructors can monitor both team
              performance and team leader activities. <br /><br />

              7) Access Control
              <br />Team Leaders have additional permissions compared to regular
              team members. <br />Instructor permissions always override Team
              Leader permissions.
            </p>
          </div>
        </div>

        <div class="pl-0 md:pl-6" v-if="activeTab === 'notification'">
          <img
            class="w-full max-w-full h-auto object-contain rounded-lg shadow-sm border border-gray-200"
            src="@/assets/help/notificationpage12.png"
            alt="Notification page"
          />
          <div class="mt-5">
            <h1 class="text-lg sm:text-xl font-semibold text-blue-600">
              Notification Read/Unread Module
            </h1>

            <p class="text-sm text-gray-700 leading-relaxed mt-5">
              1) Read/Unread Notification Management
              <br />Implemented read and unread status tracking for all
              notifications. <br />Unread notifications are clearly highlighted
              for better visibility. <br />Notifications are automatically
              marked as read when accessed by the user. <br /><br />

              2) Unread Notification Badge Counter
              <br />The notification badge displays the total number of unread
              notifications. <br />The unread count is updated in real time and
              decreases automatically when notifications are marked as read.
              <br /><br />

              3) Notification List Display
              <br />Notifications are displayed in a structured and
              user-friendly format. <br />Each notification includes an icon,
              notification message, and date/time information. <br />Read and
              unread notifications are visually distinguished for easier
              identification. <br /><br />

              4) Pagination Improvements
              <br />Added proper pagination support for the notification list.
              <br />Users can navigate between pages using previous and next
              controls. <br />Current page information and total page count are
              displayed accurately. <br />Notification data loads correctly
              across all pages. <br /><br />

              5) Performance and User Experience Enhancements
              <br />Improved notification retrieval and rendering. <br />Ensured
              synchronization between notification status and unread count.
              <br />Optimized navigation and notification management for a
              smoother user experience.
            </p>
          </div>
        </div>

        <div class="pl-0 md:pl-6" v-if="activeTab === 'messagepage'">
          <img
            class="w-full max-w-full h-auto object-contain rounded-lg shadow-sm border border-gray-200"
            src="@/assets/help/messagepage11.png"
            alt="Message notification page"
          />
          <div class="mt-5">
            <h1 class="text-lg sm:text-xl font-semibold text-blue-600">
              Message Notification Module
            </h1>

            <p class="text-sm text-gray-700 leading-relaxed mt-5">
              1) Read / Unread Notification Status
              <br />Added read and unread status tracking for all message
              notifications. <br />Unread notifications are visually highlighted
              until viewed by the user. <br />Notification count automatically
              decreases when a notification is marked as read. <br /><br />

              2) One-to-One Chat Redirection
              <br />Clicking a message notification now redirects the user
              directly to the corresponding one-to-one chat conversation.
              <br />Users can instantly view and respond to messages without
              manually searching for the sender. <br /><br />

              3) Automatic Notification Count Update
              <br />Unread message count is updated in real time. <br />Once a
              notification is opened or read, the notification badge count is
              reduced accordingly. <br /><br />

              4) Notification Content Optimization
              <br />Removed unnecessary or duplicate notification content.
              <br />Updated the notification card layout for better readability
              and cleaner presentation. <br /><br />

              5) Pagination Enhancement
              <br />Improved pagination controls for smoother navigation through
              notification history. <br />Page information is displayed clearly,
              and notifications load efficiently across multiple pages.
              <br /><br />

              6) Access Page Navigation
              <br />Added proper redirection to the relevant access page based
              on the notification type. <br />Users are taken directly to the
              related chat.
            </p>
          </div>
        </div>

        <div class="pl-0 md:pl-6" v-if="activeTab === 'profile'">
          <img
            class="w-full max-w-full h-auto object-contain rounded-lg shadow-sm border border-gray-200"
            src="@/assets/help/profilepage13.png"
            alt="Profile page"
          />
          <div class="mt-5">
            <h1 class="text-lg sm:text-xl font-semibold text-blue-600">
              User Profile Details & Profile Edit Module
            </h1>

            <p class="text-sm text-gray-700 leading-relaxed mt-5">
              1) Profile Details Page
              <br />Updated the User Profile Details page with a clean and
              structured layout. <br />Added support for displaying student
              information, including Full Name, Role, Email Address, Mobile
              Number, Batch, Program, Semester, Address, and Description/Bio.
              <br />Improved data presentation for better readability and user
              experience. <br /><br />

              2) Profile Image Management
              <br />Added profile image display functionality. <br />Users can
              upload, update, and manage their profile picture. <br />Updated
              profile image preview with improved UI and responsive design.
              <br /><br />

              3) Profile Edit Functionality
              <br />Implemented profile edit feature for updating personal
              information. <br />Users can modify editable fields directly from
              the profile page. <br />Added validation and update handling for
              profile information. <br /><br />

              4) Password Management
              <br />Added Change Password functionality. <br />Users can
              securely update their account password. <br />Improved password
              update flow and validation messages. <br /><br />

              5) UI & UX Enhancements
              <br />Updated profile card design and information layout.
              <br />Improved responsive behavior across desktop and mobile
              devices. <br />Enhanced overall profile management experience.
            </p>
          </div>
        </div>

        <div class="pl-0 md:pl-6" v-if="activeTab === 'accessible'">
          <img
            class="w-full max-w-full h-auto object-contain rounded-lg shadow-sm border border-gray-200"
            src="@/assets/help/accessiblepage14.png"
            alt="Accessible course page"
          />
          <div class="mt-5">
            <h1 class="text-lg sm:text-xl font-semibold text-blue-600">
              Accessible Course Module
            </h1>

            <p class="text-sm text-gray-700 leading-relaxed mt-5">
              1) Accessible Course List
              <br />Updated the Profile Module to display only the Accessible
              Course List when the Accessible Course tab is selected.
              <br />Ensured that only courses assigned to the logged-in student
              profile are displayed in the Accessible Course tab. <br /><br />

              2) Course Counter
              <br />Added a course counter to show the total number of courses
              assigned to the student. <br /><br />

              3) Course Search
              <br />Implemented search functionality to quickly filter courses
              by course name or course code. <br /><br />

              4) Course Table Display
              <br />Displayed course information in a structured table format
              with Course Code, Course Name, Created Date, and Status (if
              applicable). <br /><br />

              5) Rows-Per-Page Control
              <br />Added rows-per-page selection to control the number of
              courses displayed per page. <br /><br />

              6) Pagination Improvements
              <br />Improved pagination for smoother navigation through the
              course list. <br /><br />

              7) Responsive Design
              <br />Enhanced table responsiveness and user experience across
              desktop and mobile devices.
            </p>
          </div>
        </div>

        <div class="pl-0 md:pl-6" v-if="activeTab === 'task'">
          <img
            class="w-full max-w-full h-auto object-contain rounded-lg shadow-sm border border-gray-200"
            src="@/assets/help/taskmanagementpage15.png"
            alt="Task management page"
          />
          <div class="mt-5">
            <h1 class="text-lg sm:text-xl font-semibold text-blue-600">
              Task Management Module
            </h1>

            <p class="text-sm text-gray-700 leading-relaxed mt-5">
              1) Task Creation
              <br />Added Create Task functionality to help students manage
              daily activities and academic responsibilities. <br />Users can
              add new tasks using the Add button. <br />Task details such as
              title, description, and due date can be recorded for better
              organization. <br /><br />

              2) Task List Management
              <br />Added a dynamic Task Counter to display the total number of
              tasks. <br />Tasks are displayed in a clean and organized list
              format. <br />Each task shows its title, creation date, and
              current status. <br /><br />

              3) Search & Filter Features
              <br />Implemented Search functionality to quickly find tasks by
              keyword. <br />Added Status Filter dropdown to filter tasks by
              Incompleted or Completed. <br /><br />

              4) Task Completion Tracking
              <br />Added Mark as Complete functionality. <br />Completed tasks
              are visually distinguished from active tasks. <br />Users can
              easily track daily progress and incomplete work. <br /><br />

              5) Edit Task
              <br />Added Edit Task option to update task details. <br />Users
              can modify task names, descriptions, and status whenever needed.
              <br /><br />

              6) Delete Task
              <br />Added Delete Task functionality for removing unnecessary or
              completed tasks. <br />Includes confirmation handling to prevent
              accidental deletion. <br /><br />

              7) Daily Task Management
              <br />Designed for daily student productivity and task tracking.
              <br />Helps students organize assignments, reminders, project
              work, and personal study goals. <br />Provides a simple workflow:
              Create → Manage → Complete → Track Progress. <br /><br />

              8) Pagination & User Experience
              <br />Added rows-per-page selection for managing large task lists.
              <br />Improved task loading, search performance, and overall
              responsiveness. <br />Enhanced mobile and desktop viewing
              experience.
            </p>
          </div>
        </div>

        <div class="pl-0 md:pl-6" v-if="activeTab === 'userinstruction'">
          <img
            class="w-full max-w-full h-auto object-contain rounded-lg shadow-sm border border-gray-200"
            src="@/assets/help/userinstructionpage16.png"
            alt="Student instructions page"
          />
          <div class="mt-5">
            <h1 class="text-lg sm:text-xl font-semibold text-blue-600">
              Purpose of the Student Instructions Module
            </h1>

            <p class="text-sm text-gray-700 leading-relaxed mt-5">
              1) Access Academic Guidelines
              <br />View official academic policies, rules, and regulations.
              <br />Understand course requirements, examination procedures, and
              institutional standards. <br />Refer to semester-specific and
              program-specific guidelines. <br /><br />

              2) Download Instructional PDF Documents
              <br />Access and download important instructional materials in PDF
              format. <br />Review handbooks, user guides, academic calendars,
              and procedural documents. <br />Store documents for offline
              reference whenever needed. <br /><br />

              3) View Important Notices and Announcements
              <br />Stay informed about academic updates and administrative
              communications. <br />Access notices related to examinations,
              assignments, projects, attendance, and course activities.
              <br />Review official instructions published by administrators and
              faculty members. <br /><br />

              4) Stay Updated with Administrative Communications
              <br />Receive the latest instructions and policy updates from the
              institution. <br />Keep track of newly published documents and
              revised guidelines. <br />Ensure compliance with academic and
              institutional requirements. <br /><br />

              5) Support Academic Success
              <br />Provide students with clear instructions and reference
              materials. <br />Reduce confusion by maintaining all important
              documents in one location. <br />Enable quick access to
              information required for daily academic activities. <br /><br />

              6) Easy Search and Navigation
              <br />Quickly locate documents using the search feature.
              <br />Browse instructions efficiently through pagination and
              organized listings. <br />Access relevant documents without
              navigating multiple sections of the platform.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Student/Header.vue";

export default {
  components: {
    Header,
  },
  data() {
    return {
      activeTab: "login",
      showSidebar: false,
    };
  },
  methods: {
    switchTab(tab) {
      this.activeTab = tab;
      this.showSidebar = false;
    },
  },
};
</script>

<style></style>
